import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
// import "rsuite/styles/index.less"; // or 'rsuite/dist/rsuite.min.css'

export default function DateRangeSelector({ config }: any) {
  const {
    dateRangeFilterLabel,
    ranges,
    handleDateRangeFilter,
    dateRangePicker,
  } = config;

  return (
    <>
      <FormControl
        margin="dense"
        variant="outlined"
        style={{ width: "15em", marginRight: "1em" }}
        // className={classes.searchFilter}
        className="hide-print"
      >
        <InputLabel id="select-date-range">Select Date Range</InputLabel>
        <Select
          labelId="select-date-range"
          label="Type"
          style={{
            backgroundColor: "#293368",
            height: "35px",
          }}
          sx={{
            height: "35px", // Same height as Autocomplete
          }}
          value={dateRangeFilterLabel}
        >
          {ranges.map((ele: any) => {
            return (
              <MenuItem
                key={ele?.id}
                value={ele.label}
                onClick={() => {
                  handleDateRangeFilter(ele);
                }}
              >
                {ele.label}
              </MenuItem>
            );
          })}
          <MenuItem
            value="custom"
            onClick={() => {
              handleDateRangeFilter("custom");
            }}
          >
            Custom
          </MenuItem>
        </Select>
      </FormControl>
      {dateRangeFilterLabel === "custom" ? (
        <Box sx={{ mr: "1em" }}>{dateRangePicker()}</Box>
      ) : (
        <></>
      )}
    </>
  );
}
